module.exports = __webpack_public_path__ + "static/img/natural-complex-sandwitch.798f2f51.png";